import { create } from "zustand";

interface ThemeState {
  darkMode: boolean;
  setDarkMode: (value: boolean) => void;
  toggleDarkMode: () => void;
}

const useThemeStore = create<ThemeState>((set) => ({
  darkMode: (() => {
    if (typeof window !== "undefined") {
      const saved = localStorage.getItem("theme");
      return saved === "dark";
    }
    return false;
  })(),
  setDarkMode: (value) => {
    if (typeof window !== "undefined") {
      localStorage.setItem("theme", value ? "dark" : "light");
      document.documentElement.classList.toggle("dark-mode", value);
    }
    set({ darkMode: value });
  },
  toggleDarkMode: () =>
    set((state) => {
      const newValue = !state.darkMode;
      if (typeof window !== "undefined") {
        localStorage.setItem("theme", newValue ? "dark" : "light");
        document.documentElement.classList.toggle("dark-mode", newValue);
      }
      return { darkMode: newValue };
    }),
}));

export default useThemeStore;
